<template>
  <div>
    <header class="app-header">
      <router-link class="app-header__logo" to="/"><img class="d-none d-md-inline" src="../assets/logo.png"
          alt="Phonenet" /><img class="d-md-none" src="../assets/logo-icon.png" alt="Phonenet" /></router-link>
      <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Menu">
        <font-awesome-icon icon="bars" />
      </a>
      <!-- Navbar Right Menu-->
      <ul class="app-nav">
        <b-nav-item-dropdown right :toggle-class="$store.state.user.avatar ? 'app-nav__item p-0' : 'app-nav__item'"
          :style="$store.state.user.avatar ? 'padding-top: 11px' : ''">
          <template slot="button-content">
            <img v-if="$store.state.user.avatar" :src="$store.state.user.avatar"
              class="rounded-circle border border-light" style="height: 30px; width: 30px;" alt="Avatar" />
            <font-awesome-icon v-else icon="user" size="lg" />
            <span class="d-none d-lg-inline ml-1">
              {{ this.$store.state.user.name }}
              ({{ $t(this.$store.state.user.role) }} <span v-if="$store.state.user.expireTime"> -
                {{ $store.state.user.expireTime | moment('DD/MM/YYYY') }}</span>)
            </span>
          </template>
          <b-dropdown-item @click="profile">
            <font-awesome-icon icon="user" />
            {{ $t('profile') }}
          </b-dropdown-item>
          <b-dropdown-item @click="password">
            <font-awesome-icon icon="key" />
            {{ $t('changePassword') }}
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            <font-awesome-icon icon="sign-out-alt" />
            {{ $t('logOut') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
    </header>
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <aside class="app-sidebar">
      <ul class="app-menu">
        <template v-for="item in menuItems">
          <router-link v-if="!item.items && item.href && checkRole(item.roles)" :key="item.href" :to="item.href"
            v-slot="{ href, navigate, isExactActive }">
            <li>
              <a :class="[isExactActive ? 'active' : '', 'app-menu__item']" :href="href" @click="navigate">
                <span class="app-menu__icon">
                  <font-awesome-icon :icon="item.icon" />
                </span>
                <span class="app-menu__label">{{ item.name }}</span>
              </a>
            </li>
          </router-link>
          <li v-else-if="item.items && checkRole(item.roles)" :key="item.index" class="treeview">
            <a class="app-menu__item" href="#" data-toggle="treeview">
              <span class="app-menu__icon">
                <font-awesome-icon :icon="item.icon" />
              </span>
              <span class="app-menu__label">{{ item.name }}</span><i class="treeview-indicator fa fa-angle-right"></i>
            </a>
            <ul class="treeview-menu">
              <router-link v-for="i in item.items" :key="i.name" :to="i.href"
                v-slot="{ href, navigate, isExactActive }">
                <li v-if="checkRole(i.roles)">
                  <a :class="[isExactActive ? 'active' : '', 'treeview-item']" :href="href" @click="navigate">
                    <i class="icon fa fa-circle-o"></i> {{ i.name }}
                  </a>
                </li>
              </router-link>
            </ul>
          </li>
        </template>
      </ul>
      <lang></lang>
    </aside>
  </div>
</template>

<script>
import Lang from "../components/Lang";
import $ from 'jquery';

export default {
  components: { Lang },
  computed: {
    menuItems: function () {
      return [
        // ─── Tổng quan ───
        { name: this.$t('dashboard'), href: '/', icon: 'tachometer-alt' },

        // ─── Báo cáo ───
        {
          name: this.$t('report'), href: "/report/customer", icon: 'chart-bar',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager', 'marketing'],
          items: [
            {
              name: this.$t('clientReport'), href: '/report/client',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('referralReport'), href: '/report/referral',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('contractReport'), href: '/report/contract',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('creditBalance'), href: '/report/credit-balance',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
            },
            {
              name: this.$t('callReport'), href: '/report/call',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('callFeeOverview'), href: '/report/call-fee-overview',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
            },
            {
              name: this.$t('callFeeDetail'), href: '/report/call-fee-detail',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
            },
            {
              name: this.$t('callPackage'), href: '/report/call-package',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager', 'manager']
            },
            {
              name: this.$t('planOrder'), href: '/report/plan-order',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('promotionOnOrder'), href: '/report/promotion',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            { name: this.$t('finance'), href: '/report/finance' },
            {
              name: this.$t('usageReport'), href: '/report/usage',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
            {
              name: this.$t('quantityReport'), href: '/report/quantity',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
            },
          ]
        },

        // ─── Tài chính ───
        {
          name: this.$t('finance'), href: "/credit-deposit", icon: 'credit-card',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager'],
          items: [
            { name: this.$t('creditDeposit'), href: '/credit-deposit' },
            { name: this.$t('creditTransaction'), href: '/credit-transaction' },
            { name: this.$t('planOrder'), href: '/plan-order' },
            { name: this.$t('clientPackage'), href: '/client-package' },
            { name: this.$t('clientCDP'), href: '/client-cdp' },
            { name: this.$t('aiAgentOrder'), href: '/client-chatbot' },
            { name: this.$t('invoicePlanOrder'), href: '/invoice-plan-order' },
            {
              name: this.$t('phoneNumberSetupTransaction'), href: '/phone-number-setup-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('phoneNumberSubscriptionTransaction'), href: '/phone-number-subscription-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('smsBrandNameRegisterTransaction'), href: '/sms-brand-name-register-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('smsBrandNameSubscriptionTransaction'), href: '/sms-brand-name-subscription-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('numberBrandNameSetupTransaction'), href: '/number-brand-name-setup-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('numberBrandNameSubscriptionTransaction'), href: '/number-brand-name-subscription-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('callRefundSubscriptionTransaction'), href: '/call-refund-subscription-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('phoneNumberCommitTransaction'), href: '/phone-number-commit-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            {
              name: this.$t('viberBrandNameCommitTransaction'), href: '/viber-brandname-commit-transaction',
              roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
            },
            // Hoá đơn VAT
            { name: this.$t('supplier'), href: '/invoice-gateway', roles: ['owner'] },
            { name: this.$t('vatInvoice') + ' - ' + this.$t('plan'), href: '/invoice-plan', roles: ['owner'] },
            { name: this.$t('vatInvoice') + ' - ' + this.$t('setup'), href: '/invoice-setup', roles: ['owner'] },
          ]
        },

        // ─── Khách hàng ───
        {
          name: this.$t('client'), href: "/client", icon: 'user-tie',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup'],
          items: [
            {
              name: this.$t('lead'), href: '/client-lead',
              roles: ['owner', 'admin', 'tech', 'sales', 'kpiSales', 'am', 'manager']
            },
            {
              name: this.$t('clientRegister'), href: '/client-register',
              roles: ['owner', 'admin', 'tech', 'sales', 'kpiSales', 'marketing', 'marketingManager', 'manager']
            },
            { name: this.$t('client'), href: '/client' },
            {
              name: this.$t('invoiceInfo'), href: '/invoice-info',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant']
            },

            {
              name: this.$t('kycRequest.title'), href: '/client/kyc-request',
              roles: ['owner', 'admin', 'tech', 'operationsManager', 'sales', 'salesAssistant', 'account', 'accountant', 'am', 'manager', 'supervisor']
            },
            {
              name: this.$t('clientKYC'), href: '/client-kyc',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
            },

            {
              name: this.$t('clientTrialExtendRequest'), href: '/client-trial-extend-request',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
            },
            {
              name: this.$t('plan'), href: '/plan',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
            },
            { name: this.$t('promotion'), href: '/promotion', roles: ['owner', 'admin', 'account'] },
            {
              name: this.$t('callHistory'), href: '/call',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup']
            },
            // Ecommerce
            {
              name: this.$t('product'), href: '/admin-product',
              roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager', 'accountant']
            },
            {
              name: this.$t('order'), href: '/admin-order',
              roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager', 'accountant']
            },
            // Tra cứu
            {
              name: this.$t('lookup') + ' - ' + this.$t('adminCall'), href: '/lookup-call',
              roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']
            },
            {
              name: this.$t('lookup') + ' - ' + this.$t('client'), href: '/lookup-customer',
              roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']
            },
          ]
        },

        // ─── Viễn thông ───
        {
          name: this.$t('phone'), href: "/host", icon: 'phone',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager', 'sales', 'kpiSales'],
          items: [
            { name: this.$t('phoneHost'), href: '/host', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
            { name: this.$t('gateway'), href: '/gateway', roles: ['owner', 'admin', 'tech', 'operationsManager', 'am', 'account'] },
            { name: this.$t('phoneNetwork'), href: '/phone-network', roles: ['owner', 'admin', 'tech', 'operationsManager', 'am', 'account'] },
            { name: this.$t('phoneNumber'), href: '/number' },
            { name: 'DNC', href: '/dnc', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
            { name: this.$t('systemRecording'), href: '/system-recording', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
            // Phát hiện lỗi
            {
              name: this.$t('faultDetection') + ' - ' + this.$t('keyword'), href: '/fault-detection-keyword',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
            },
            {
              name: this.$t('faultDetection') + ' - ' + this.$t('callFaultDetection'), href: '/fault-detection-call',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
            },
            {
              name: this.$t('faultDetection') + ' - Chat', href: '/fault-detection-chat',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am']
            },
            {
              name: this.$t('faultDetection') + ' - IP', href: '/fault-detection-ip',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
            },
          ]
        },

        // ─── Chiến dịch & Tin nhắn ───
        {
          name: this.$t('campaign') + ' & ' + this.$t('message'), icon: 'rocket',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager', 'ctvCall'],
          items: [
            // Chiến dịch
            {
              name: this.$t('massCall'), href: '/call-campaign',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager']
            },
            {
              name: this.$t('messageCampaign'), href: '/message-campaign',
              roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am']
            },
            { name: this.$t('emailCampaign'), href: '/email-campaign' },
            // Tin nhắn
            { name: 'SMS', href: '/sms' },
            { name: 'Viber', href: '/viber' },
            { name: 'ZNS', href: '/zns' },
            { name: this.$t('socialNetworkAccounts'), href: '/social-network-account' },
            { name: this.$t('clientBot'), href: '/client-bot', roles: ['owner', 'admin', 'tech', 'account', 'am'] },
            // Email Marketing
            { name: this.$t('emailTemplate'), href: '/email-template-callio' },
            { name: 'Email Sender', href: '/email-sender' },
            // Gọi tự động
            {
              name: this.$t('aiAdminCall') + ' - ' + this.$t('report'), href: '/admin-call-report',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager']
            },
            {
              name: this.$t('aiAdminCall') + ' - ' + this.$t('adminCall'), href: '/admin-call',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager']
            },
            {
              name: this.$t('aiAdminCall') + ' - ' + this.$t('adminCalltranslate'), href: '/admin-call-translate',
              roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'ctvCall', 'am']
            },
          ]
        },

        // ─── AI ───
        {
          name: 'AI', icon: 'robot',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager'],
          items: [
            { name: 'AI Trợ lý - Tổng quan', href: '/ai-assistant' },
            { name: 'AI Trợ lý - Nhật ký', href: '/ai-assistant-logs' },
            { name: 'AI Agent - Tổng quan', href: '/ai-agent' },
            { name: 'AI Agent - Nhật ký', href: '/ai-agent-logs' },
            { name: 'AI Agent - Billing Overview', href: '/ai-agent-overview' },
            { name: 'AI Gateway', href: '/ai-gateway' },
          ]
        },

        // ─── Cài đặt (gom Nhân viên + Token) ───
        {
          name: this.$t('setup'), icon: 'cogs',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager'],
          items: [
            // Nhân viên
            {
              name: this.$t('adminUser'), href: '/admin-user',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
            },
            {
              name: this.$t('setupKPI'), href: '/admin-user-kpi',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
            },
            {
              name: this.$t('department'), href: '/department',
              roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
            },
            { name: 'Category', href: '/category', roles: ['owner', 'admin'] },
            // Cài đặt hệ thống
            { name: this.$t('logisticsCompany'), href: '/carrier-gateway', roles: ['owner', 'admin', 'tech'] },
            { name: this.$t('printTemplate'), href: '/print-template', roles: ['owner', 'admin', 'tech'] },
            { name: this.$t('country'), href: '/country', roles: ['owner', 'admin', 'tech'] },
            { name: this.$t('parameter'), href: '/etc', roles: ['owner', 'admin', 'tech'] },
            { name: 'Popup', href: '/admin-popup', roles: ['owner', 'admin', 'tech'] },
            { name: 'Tiện ích', href: '/tool', roles: ['owner', 'admin', 'tech', 'account', 'am', 'manager'] },
            { name: 'Gửi thông báo', href: '/error-notification', roles: ['owner', 'admin', 'tech'] },
            { name: 'Release Notes', href: '/release-note', roles: ['owner', 'admin', 'tech'] },
            { name: 'Vấn đề thường gặp', href: '/error', roles: ['owner', 'admin', 'tech', 'account', 'am', 'sales', 'kpiSales'] },
            { name: this.$t('mappingZaloUser'), href: '/mapping-zalo-user', roles: ['owner', 'admin', 'tech'] },
            { name: 'Sitemap', href: '/sitemap' },
            { name: 'Token', href: '/token' },
          ]
        },

        // ─── Nhật ký (gom tất cả log) ───
        {
          name: this.$t('logs'), icon: 'history',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am'],
          items: [
            { name: this.$t('logCustomerActivity'), href: '/activity-history', roles: ['owner', 'admin', 'tech', 'account'] },
            { name: this.$t('logSocialAccountChange'), href: '/social-network-account-history' },
            { name: this.$t('logChatSession'), href: '/chat-history' },
            { name: this.$t('logEmailSent'), href: '/email-history' },
            { name: this.$t('logBotDetect'), href: '/bot-detect-history' },
            { name: this.$t('logPointTransaction'), href: '/point-transaction-history' },
            { name: this.$t('logWebhookVietguys'), href: '/webhook-vietguys', roles: ['owner', 'admin', 'tech', 'account', 'am'] },
            { name: this.$t('logHiloInvoice'), href: '/hilo-invoice-log', roles: ['owner'] },
            { name: this.$t('logSocialWebhook'), href: '/social-webhook-log', roles: ['owner', 'admin', 'tech'] },
          ]
        },
      ];
    }
  },
  i18n: {
    messages: {
      en: {
        promotions: 'Promotion',
        dashboard: 'Dashboard',
        client: 'Client',
        clientRegister: 'Client register',
        clientKYC: 'Client KYC',
        callFeeOverview: 'Call fee overview',
        callFeeDetail: 'Call fee detail',
        plan: 'Plan',
        creditDeposit: 'Credit deposit',
        phoneNumber: 'Phone numbers',
        phoneHost: 'Phone hosts',
        country: 'Country',
        phoneNetwork: 'Phone network',
        adminUser: 'Admin users',
        profile: 'My profile',
        changePassword: 'Change password',
        logOut: 'Logout',
        systemRecording: 'System recording',
        creditTransaction: 'Credit transaction',
        report: "Report",
        clientReport: "Client",
        systemUsageReport: "System Usage",
        financeReport: "Finance",
        callReport: "Call",
        callTrafficReport: "Call traffic",
        customerReport: "Customer",
        sms: "SMS",
        emailMarketing: "Email",
        planOrder: "Plan order",
        subscriptionTransaction: "Subscription",
        callHistory: 'Call history',
        campaign: 'Campaign',
        smsHistory: 'SMS history',
        znsHistory: 'ZNS history',
        phoneNumberSetupTransaction: 'Phone number setup transaction',
        smsBrandNameRegisterTransaction: 'SMS brand name register transaction',
        phoneNumberSubscriptionTransaction: 'Phone number subscription transaction',
        smsBrandNameSubscriptionTransaction: 'SMS brand name subscription transaction',
        numberBrandNameSetupTransaction: 'Number brand name setup transaction',
        numberBrandNameSubscriptionTransaction: 'Number braVnd name subscription transaction',
        commissionConfig: 'Commission config',
        role: 'Role',
        department: 'Department',
        kpiSetup: 'KPI setup',
        commission: 'Commission',
        commissionList: 'Commission list',
        adminUserCommission: 'Employee commission',
        zns: 'ZNS',
        znsSupplier: 'ZNS Supplier',
        znsTemplate: 'ZNS Template',
        phone: 'Tele Phone',
        aiAPP: "AI APP",
        aiCall: "Auto call",
        aiTemplate: 'Call Template',
        cluster: "Cluster",
        flex: "Flex Package",
        faultDetection: "Fault Detection",
        callFaultDetection: "Suspicious call",
        keyword: "Keyword",
        viber: "Viber",
        viberHistory: "Viber history",
        creditBalance: "Credit Balance",
        message: "Message",
        messageCampaign: "Message campaign",
        phonebook: 'Phonebook',
        aiHistory: "History",
        contractReport: "Contract",
        parameter: "Parameter",
        emailCampaign: "Email Campaign",
        setupKPI: "Setup KPI",
        setup: "Setup",
        promotionOnOrder: "Promotion on orders",
        lead: 'Lead',
        emailTemplate: 'Template',
        phoneNumberCommitTransaction: "Phone number commit transaction",
        viberBrandNameCommitTransaction: "Viber brandName commit transaction",
        massCall: "Mass call",
        clientCDP: "CDP package",
        marketingManager: "Marketing Manager",
        referralReport: "Referral",
        emailHistory: "Email history",
        socialNetworkAccounts: "Social network account",
        planOrderByMonth: "Plan order by month",
        usageReport: 'Usage',
        callPackage: 'All-inclusive calling package',
        order: 'Order',
        printTemplate: 'Print template',
        logisticsCompany: 'Logistics company',
        chatSession: "Chat session",
        chatFaultDetection: "Suspicious chat",
        quantityReport: "Quantity",
        mappingZaloUser: 'List of personal Zalo customers',
        callRefundSubscriptionTransaction: "Refund of call charges",
        activityHistory: "Activity history",
        logs: "Logs",
        logCustomerActivity: "Customer activity",
        logSocialAccountChange: "Social account changes",
        logChatSession: "Chat sessions",
        logEmailSent: "Sent emails",
        logBotDetect: "Bot detection",
        logPointTransaction: "Point transactions",
        logAiAssistant: "AI Assistant",
        logAiAgent: "AI Agent",
        logWebhookVietguys: "Webhook Vietguys",
        logHiloInvoice: "Hilo VAT invoice API",
        logSocialWebhook: "Social network webhook",
        product: "Product",
        aiAdminCall: "Xử lý cuộc gọi AI",
        adminCall: "Cuộc gọi",
        adminCalltranslate: "Biên dịch",
        lookup: "Tra cứu",
        kpiSales: "KPI sales",
        aiAgentOrder: "AI agent order",
        clientBot: "Client Bot",
        socialNetworkAccountsHistory: "Social network account history",
        botDetectHistory: "Bot detect history",
        pointTransactionHistory: "Point transaction history",
        chatHistory: "Chat history",
        invoiceInfo: "Invoice info",
        sitemap: "Sitemap",
        vatInvoice: "Electronic invoice",
        supplier: "Supplier",
        invoicePlanOrder: "Electronic invoice order",
        ipFaultDetection: "Suspicious customers",
      },
      vi: {
        promotion: 'Khuyến mãi',
        keyword: 'Từ khóa',
        dashboard: 'Tổng quan',
        client: 'Khách hàng',
        clientRegister: 'Đăng ký dùng thử',
        clientKYC: 'Hồ sơ khách hàng',
        callFeeOverview: 'Cước gọi tổng quan',
        callFeeDetail: 'Cước gọi chi tiết',
        plan: 'Gói dịch vụ',
        creditDeposit: 'Lệnh nạp tiền',
        phoneNumber: 'Số điện thoại',
        phoneHost: 'Tổng đài',
        country: 'Quốc gia',
        phoneNetwork: 'Mạng',
        adminUser: 'Tài khoản',
        profile: 'Hồ sơ cá nhân',
        changePassword: 'Đổi mật khẩu',
        logOut: 'Thoát tài khoản',
        systemRecording: 'File ghi âm',
        creditTransaction: 'Lịch sử giao dịch',
        report: "Báo cáo",
        clientReport: "Khách hàng",
        systemUsageReport: "Sử dụng hệ thống",
        financeReport: "Tài chính",
        callReport: "Cuộc gọi",
        callTrafficReport: "Lưu lượng gọi",
        customerReport: "Khách hàng",
        sms: "SMS",
        emailMarketing: "Email",
        planOrder: "Đơn hàng gói dịch vụ",
        subscriptionTransaction: "Thuê bao hàng tháng",
        callHistory: 'Lịch sử gọi',
        campaign: 'Chiến dịch',
        smsHistory: 'Lịch sử SMS',
        znsHistory: 'Lịch sử ZNS',
        phoneNumberSetupTransaction: 'Phí khởi tạo số',
        smsBrandNameRegisterTransaction: 'Phí đăng ký SMS brandname',
        phoneNumberSubscriptionTransaction: 'Phí duy trì số',
        smsBrandNameSubscriptionTransaction: 'Phí duy trì brandname',
        numberBrandNameSetupTransaction: 'Phí khởi tạo brandname số',
        numberBrandNameSubscriptionTransaction: 'Phí duy trì brandname số',
        commissionConfig: 'Cài đặt hoa hồng',
        role: 'Phân quyền',
        department: 'Phòng ban',
        kpiSetup: 'Cài đặt KPI',
        commission: 'Hoa hồng',
        commissionList: 'Danh sách chi tiết',
        adminUserCommission: 'Hoa hồng nhân viên',
        zns: 'ZNS',
        znsSupplier: 'Nhà cung cấp ZNS',
        znsTemplate: 'Mẫu tin nhắn ZNS',
        phone: 'Điện thoại',
        aiAPP: "Bot gọi",
        aiCall: "Gọi tự động",
        aiTemplate: 'Mẫu cuộc gọi',
        cluster: "Cluster",
        flex: "Gói Flex",
        faultDetection: "Vi phạm",
        callFaultDetection: "Cuộc gọi nghi ngờ",
        viber: "Viber",
        viberHistory: "Lịch sử Viber",
        creditBalance: "Số dư khách hàng",
        message: "Tin nhắn",
        messageCampaign: "Chiến dịch tin nhắn",
        phonebook: 'Danh bạ số',
        aiHistory: "Lịch sử",
        contractReport: "Hợp đồng",
        parameter: "Tham số",
        emailCampaign: "Chiến dịch email",
        setupKPI: "Cài đặt KPI",
        setup: "Cài đặt",
        promotionOnOrder: "Khuyến mãi trên đơn hàng",
        lead: 'Tiềm năng',
        emailTemplate: 'Mẫu email',
        phoneNumberCommitTransaction: "Số điện thoại cam kết",
        viberBrandNameCommitTransaction: "Viber brandname cam kết ",
        massCall: "Gọi hàng loạt",
        clientCDP: "Đơn hàng gói CDP",
        marketingManager: "Quản lý Marketing",
        referralReport: "Giới thiệu",
        emailHistory: "Lịch sử email",
        socialNetworkAccounts: "Tài khoản mạng xã hội",
        planOrderByMonth: "Đơn hàng",
        usageReport: 'Sử dụng',
        callPackage: 'Gói gọi trọn gói',
        order: 'Đơn hàng',
        printTemplate: 'Mẫu in',
        logisticsCompany: 'Hãng vận chuyển',
        chatSession: "Phiên chat",
        chatFaultDetection: "Tin nhắn nghi ngờ",
        quantityReport: "Sản lượng",
        mappingZaloUser: "Danh sách KH Zalo cá nhân",
        callRefundSubscriptionTransaction: "Hoàn tiền cước gọi",
        activityHistory: "Lịch sử hoạt động",
        logs: "Nhật ký",
        logCustomerActivity: "Hoạt động khách hàng",
        logSocialAccountChange: "Tài khoản MXH — Thay đổi",
        logChatSession: "Phiên chat",
        logEmailSent: "Email đã gửi",
        logBotDetect: "Phát hiện bot",
        logPointTransaction: "Giao dịch điểm",
        logAiAssistant: "AI Trợ lý",
        logAiAgent: "AI Agent",
        logWebhookVietguys: "Webhook Vietguys",
        logHiloInvoice: "API Hoá đơn VAT Hilo",
        logSocialWebhook: "Nhật ký MXH",
        product: "Sản phẩm",
        aiAdminCall: "Xử lý cuộc gọi AI",
        adminCall: "Cuộc gọi",
        adminCalltranslate: "Biên dịch",
        lookup: "Tra cứu",
        kpiSales: "KPI sales",
        aiAgentOrder: "Đơn hàng nhân viên AI",
        clientBot: "Tài khoản tích hợp",
        socialNetworkAccountsHistory: "Lịch sử tài khoản mạng xã hội",
        botDetectHistory: "Lịch sử giám sát giao tiếp",
        pointTransactionHistory: "Lịch sử tích điểm",
        chatHistory: "Lịch sử chat",
        invoiceInfo: "Thông tin xuất hóa đơn",
        sitemap: "Sitemap",
        vatInvoice: "Hoá đơn điện tử",
        supplier: "Nhà cung cấp",
        invoicePlanOrder: "Đơn hàng hoá đơn điện tử",
        ipFaultDetection: "Khách hàng nghi ngờ",
      }
    }
  },
  methods: {
    checkRole: function (roles) {
      if (!roles || roles.length === 0) {
        return true;
      }
      if (roles.find(role => this.$store.state.user.role === role)) {
        return true;
      }
      return false;
    },
    logout: function () {
      sessionStorage.removeItem('token');
      localStorage.removeItem('token');
      this.$service.defaults.headers.common['token'] = null;
      this.$bgService.defaults.headers.common['token'] = null;
      this.$store.commit('user', null);
      this.$router.push('/login');
    },
    profile: function () {
      this.$store.commit('showProfileForm', true);
    },
    password: function () {
      this.$store.commit('showPasswordForm', true);
    },
  },
  mounted: function () {
    let treeviewMenu = $('.app-menu');
    let viewportGlobal = $(window).width();

    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
        $(this).parent().addClass('is-expanded');
      } else {
        $(this).parent().removeClass('is-expanded');
      }
    });

    $("[data-toggle='treeview'].is-expanded").parent().toggleClass('is-expanded');
    $("[data-toggle='tooltip']").tooltip();

    if (viewportGlobal < 768) {
      $('.app-menu__item').click(function (event) {
        event.preventDefault();
        //$('.app').toggleClass('sidenav-toggled');
      });
    }

    setTimeout(function () {
      $('.app-menu a').each(function () {
        if ($(this).hasClass('active')) {
          $(this).parents('li.treeview').addClass('is-expanded');
        }
      });
    }, 300);
  }
};
</script>
